import { motion } from "framer-motion";
import { Play, Pause, SkipBack, SkipForward, ChevronUp } from "lucide-react";

export default function MiniPlayerBar({
  title,
  subtitle,
  isPlaying,
  isBusy = false,
  progress = 0,
  onPlayPause,
  onSkipBack,
  onSkipForward,
  onExpand,
}) {
  return (
    <motion.div
      data-testid="mini-player-bar"
      initial={{ y: 90, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 90, opacity: 0 }}
      transition={{ type: "spring", stiffness: 320, damping: 28 }}
      className="sm:hidden fixed bottom-0 inset-x-0 z-[60]"
    >
      <div className="h-1 bg-white/10">
        <div
          className="h-full bg-gradient-to-r from-purple-500 to-amber-400 transition-[width]"
          style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
        />
      </div>
      <div
        data-testid="mini-player-expand"
        onClick={onExpand}
        className="glass-card border-t border-purple-500/20 flex items-center gap-3 px-4 py-2.5 cursor-pointer"
        style={{ paddingBottom: "max(0.625rem, env(safe-area-inset-bottom))" }}
      >
        <button
          data-testid="mini-player-play-pause"
          onClick={(e) => { e.stopPropagation(); onPlayPause(); }}
          disabled={isBusy}
          className="w-10 h-10 rounded-full bg-gradient-to-r from-purple-600 to-amber-500 flex items-center justify-center text-white shrink-0 disabled:opacity-60"
        >
          {isBusy ? (
            <span className="w-4 h-4 rounded-full border-2 border-white/40 border-t-white animate-spin" />
          ) : isPlaying ? (
            <Pause size={16} />
          ) : (
            <Play size={16} className="ml-0.5" />
          )}
        </button>
        <div className="flex-1 min-w-0">
          <p data-testid="mini-player-title" className="text-sm font-medium text-white truncate">{title}</p>
          {subtitle && <p data-testid="mini-player-subtitle" className="text-xs text-slate-400 truncate">{subtitle}</p>}
        </div>
        {(onSkipBack || onSkipForward) && (
          <div className="flex items-center gap-0.5 shrink-0">
            {onSkipBack && (
              <button
                data-testid="mini-player-skip-back"
                onClick={(e) => { e.stopPropagation(); onSkipBack(); }}
                disabled={isBusy}
                className="min-h-[40px] min-w-[40px] flex items-center justify-center text-slate-300 disabled:opacity-40"
              >
                <SkipBack size={15} />
              </button>
            )}
            {onSkipForward && (
              <button
                data-testid="mini-player-skip-forward"
                onClick={(e) => { e.stopPropagation(); onSkipForward(); }}
                disabled={isBusy}
                className="min-h-[40px] min-w-[40px] flex items-center justify-center text-slate-300 disabled:opacity-40"
              >
                <SkipForward size={15} />
              </button>
            )}
          </div>
        )}
        <ChevronUp size={16} className="text-slate-500 shrink-0" />
      </div>
    </motion.div>
  );
}
